import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VigorBuyGuide from "../pages/guide/page";
import VigorBuyCategories from "../pages/categories/page";
import VigorBuySafety from "../pages/safety/page";
import VigorBuyComparison from "../pages/comparison/page";
import VigorBuyBeginnerGuide from "../pages/beginner/page";
import VigorBuyQCPhotos from "../pages/qc-photos/page";
import VigorBuyTopProducts from "../pages/top-products/page";
import VigorBuyAdvancedStrategies from "../pages/advanced-strategies/page";
import VigorBuyBuyingTips from "../pages/buying-tips/page";
import VigorBuy2026Review from "../pages/2026-review/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-spreadsheet-guide",
    element: <VigorBuyGuide />,
  },
  {
    path: "/vigorbuy-spreadsheet-categories",
    element: <VigorBuyCategories />,
  },
  {
    path: "/vigorbuy-spreadsheet-safety",
    element: <VigorBuySafety />,
  },
  {
    path: "/vigorbuy-spreadsheet-comparison",
    element: <VigorBuyComparison />,
  },
  {
    path: "/vigorbuy-beginner-guide",
    element: <VigorBuyBeginnerGuide />,
  },
  {
    path: "/vigorbuy-qc-photos",
    element: <VigorBuyQCPhotos />,
  },
  {
    path: "/vigorbuy-top-products",
    element: <VigorBuyTopProducts />,
  },
  {
    path: "/vigorbuy-advanced-strategies",
    element: <VigorBuyAdvancedStrategies />,
  },
  {
    path: "/vigorbuy-buying-tips",
    element: <VigorBuyBuyingTips />,
  },
  {
    path: "/vigorbuy-2026-review",
    element: <VigorBuy2026Review />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;